import { request } from "../../apis";

export const apiCheckIfHiddenStore = (params: any): any =>
  request("get", `/api/store/check`, params, false);

export const apiGetHiddenStoreItem = (params: any): any =>
  request("get", `/api/store/item`, params, false);
